import { createFileRoute } from "@tanstack/react-router";

import { SettingsScreen } from "../features/settings/components/SettingsScreen.tsx";

type SettingsSearch = { tab?: string };

export const Route = createFileRoute("/_app/settings")({
  validateSearch: (search: Record<string, unknown>): SettingsSearch => ({
    tab: typeof search.tab === "string" ? search.tab : undefined,
  }),
  component: SettingsPage,
});

function SettingsPage() {
  const { tab } = Route.useSearch();
  return <SettingsScreen initialTab={tab} />;
}
